import {BaseFormModel} from './base-form-model';
import {Feature} from './feature';

export class OrganizationRole extends BaseFormModel<OrganizationRole> {
    id: number;
    name: string;
    description: string;
    features: Feature[];
}
